import React, { useState } from 'react'
import { Modal } from 'components'
import { UploadExcel, ConfirmData, ProgressReport } from 'features/Onboarding'
import { DownloadTemplate } from 'features/Onboarding/DownloadTemplate'

export interface FileDataProps {
  name: string
  size: number
}
interface props {
  type: string
  isOpen: boolean
  onClose: () => void
  onDownload?: () => void
}

export const OnboardingContainer = (props: props): JSX.Element => {
  const { isOpen, onClose, type, onDownload } = props
  const [steps, setSteps] = useState<number>(1)
  const [dataSource, setDataSource] = useState<[][]>([])
  const [fileData, setFileData] = useState<FileDataProps | undefined>(undefined)

  const onCancel = () => {
    setSteps(1)
    onClose()
  }

  const renderModal = (step: number) => {
    switch (step) {
      case 1:
        return (
          <DownloadTemplate
            setSteps={() => setSteps(2)}
            onClose={onCancel}
            onDownload={onDownload}
            type={type}
          />
        )
      case 2:
        return (
          <UploadExcel
            setSteps={() => {
              if (dataSource.length !== 0) {
                setSteps(3)
              }
            }}
            onClose={onCancel}
            setDataSource={setDataSource}
            setFileData={(e) => setFileData(e)}
            type={type}
          />
        )
      case 3:
        return (
          <ConfirmData
            dataSource={dataSource}
            setSteps={() => setSteps(4)}
            onPrev={() => setSteps(2)}
            type={type}
          />
        )
      case 4:
        return (
          <ProgressReport
            file={fileData}
            setSteps={() => onCancel}
            onClose={onCancel}
          />
        )
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} isIcon={false}>
      {renderModal(steps)}
    </Modal>
  )
}
